import * as React from 'react'
import * as D from '@/domain'
import { FormattedMessage, useIntl } from 'react-intl'
import * as M from '@/materials'
import { commonDescriptors } from '../locale/messages'

interface Props {
  ballotVariant: M.BallotVariant
  outcome: D.Outcome
}

/**
 * Maps an outcome to "Ja" / "Nein" or "Initiative" / "Gegenvorschlag" (depending
 * on ballot variant).
 *
 * Notes:
 *  - In some places we use "Angenommen" / "Abgelehnt". This component does not support
 *    that use case.
 *  - The labels for tiebreak are customizable in the backoffice. This component does not
 *    use those and always renders "Initiative" / "Gegenvorschlag".
 */
export function OutcomeLabelFragment(props: Props) {
  const intl = useIntl()
  const { ballotVariant, outcome } = props

  return {
    default: (
      <FormattedMessage
        id="h6r3GYC"
        defaultMessage="{outcome, select, yea { Ja } nay { Nein } other {WAT} }"
        values={{ outcome }}
      />
    ),
    tieBreak: <>{intl.formatMessage(commonDescriptors.tiebreakLabel, { outcome })}</>,
  }[ballotVariant]
}
